export default __webpack_public_path__ + "static/media/kids-studying.24cbd2b5.svg";